
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'timeline': {
    width: 18,
    height: 19,
    viewBox: '0 0 18 19',
    data: '<path fill-rule="evenodd" clip-rule="evenodd" d="M0 1.5C0 0.671573 0.671573 0 1.5 0C2.32843 0 3 0.671573 3 1.5C3 2.32843 2.32843 3 1.5 3C0.671573 3 0 2.32843 0 1.5ZM5.25 1.5L6.75 0H14.25C14.664 0 15 0.336 15 0.75V2.25C15 2.664 14.664 3 14.25 3H6.75L5.25 1.5ZM1.5 6C0.671573 6 0 6.67157 0 7.5C0 8.32843 0.671573 9 1.5 9C2.32843 9 3 8.32843 3 7.5C3 6.67157 2.32843 6 1.5 6ZM5.25 7.5L6.75 6H17.25C17.664 6 18 6.336 18 6.75V8.25C18 8.664 17.664 9 17.25 9H6.75L5.25 7.5ZM1.5 12C0.671573 12 0 12.6716 0 13.5C0 14.3284 0.671573 15 1.5 15C2.32843 15 3 14.3284 3 13.5C3 12.6716 2.32843 12 1.5 12ZM5.25 13.5L6.75 12H11.25C11.664 12 12 12.336 12 12.75V14.25C12 14.664 11.664 15 11.25 15H6.75L5.25 13.5Z" fill="#414162"/>'
  }
})
